import System from "src/helper/system";
import Helper from "src/helper/Helper";
import Product from "./product";
class HomePages {
    // static BROWSE_TABS_CONTENT = System.getAutosuggestUrl() + '/search/resources/store/10151/sitecontent/webContentsBySearchTerm/select'
    static CONTENT_TAB_COUNT_NEW = System.getApplicationUrl() + '/api/application/webSearchContent/count'
    static ALL_CONTENT_TAB = System.getApplicationUrl() + '/api/application/webSearchContent'

    static getHomeTabsListRouteURL(extra_c = {}) {
        return this.getURLBasedOnParamKey({
            ...extra_c
        });
    }

    static makeHomeTabsListRouteURL(param_value) {
        return this.getHomeTabsListRouteURL({
            [Helper.plpTabParam]: param_value
        });
    }

    static getURLBasedOnParamKey(c) {
        return Product.getProductListingPageRouteURL(c);
    }
}

export default HomePages;